import { Slide } from '@features/powerpoint';
import { BuildPresentationProps } from './build-presentation';
import { overviewSlideInterface } from '../../../slides/overview-slide-interface';
import { formatters } from '@utils/formattersV2';

const valueIfPresent = (value: string | undefined) =>
  value && value.length > 0 ? value : null;

export const overviewSlideFromProps = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] => {
  return props.customFields.includedSlides.overall.overview
    ? [
        overviewSlideInterface({
          flightDates: [props.campaign.startDate, props.campaign.endDate],
          measurementDates: [
            props.campaign.startDate,
            props.selectedReportDate,
          ],
          metrics: [
            {
              name: 'Impressions',
              value: formatters.number(props.visitMetrics.impressions ?? 0, {
                full: true,
              }),
            },
            {
              name: 'Users Matched for Attribution',
              value: formatters.number(
                props.visitMetrics.matchedForAttribution,
                {
                  full: true,
                }
              ),
            },
            {
              name: 'Unique Users',
              value: formatters.users(props.visitMetrics.uniqueUsers, {
                full: true,
              }),
            },
            {
              name: 'Media Spend',
              value: formatters.currency(props.calculatedFields.adSpend, {
                full: true,
                decimals: 0,
              }),
            },
          ],
          reportsIncluded: [
            'Foot Traffic Attribution',
            ...(props.salesSummary ? (['Sales Attribution'] as const) : []),
          ],
          reportingDimensions: props.subdimensions.map(subdimension => {
            const dimension =
              props.customFields.dimensions[
                subdimension.name as keyof typeof props.customFields.dimensions
              ];
            return (
              valueIfPresent(dimension?.visitsTableHeader) ??
              valueIfPresent(dimension?.salesTableHeader) ??
              subdimension.name
            );
          }),
          slideMaster,
        }),
      ]
    : [];
};
